import React, { Component } from "react";
import Login from "components/UnauthorizedComponents/Login";
export default class LoginAndRegister extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-6 ml-auto mr-auto">
            <div className="card">
              <div className="card-header card-header-tabs card-header-primary">
                <div className="nav-tabs-navigation">
                  <div className="nav-tabs-wrapper">
                    <ul
                      className="nav nav-tabs login-and-register"
                      data-tabs="tabs"
                    >
                      <li className="nav-item text-center">
                        <a
                          className={`nav-link ${
                            window.location.href.includes("login")
                              ? "active"
                              : ""
                          }`}
                          href="#login"
                          data-toggle="tab"
                        >
                          <i className="material-icons">person</i> Login
                          <div className="ripple-container"></div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className="tab-content">
                  <div
                    className={`tab-pane ${
                      window.location.href.includes("login") ? "active" : ""
                    }`}
                    id="login"
                  >
                    <Login />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
